
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loadScript = require('load-script');

var defaultScriptUrl = 'https://cdn.jsdelivr.net/npm/ckeditor-full@4.7.3/ckeditor.min.js';

/**
 * @author codeslayer1
 * @description CKEditor component to render a CKEditor textarea with defined configs and all CKEditor events handler
 */

var CKEditor = function (_React$Component) {
  _inherits(CKEditor, _React$Component);

  function CKEditor(props) {
    _classCallCheck(this, CKEditor);

    //Bindings
    var _this = _possibleConstructorReturn(this, (CKEditor.__proto__ || Object.getPrototypeOf(CKEditor)).call(this, props));

    _this.onLoad = _this.onLoad.bind(_this);

    //State initialization
    _this.state = {
      isScriptLoaded: props.isScriptLoaded
    };
    return _this;
  }

  //load ckeditor script as soon as component mounts if not already loaded


  _createClass(CKEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.isScriptLoaded) {
        loadScript(this.props.scriptUrl, this.onLoad);
      } else {
        this.onLoad();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var editor = this.editorInstance;
      if (editor && editor.getData() !== props.content) {
        editor.setData(props.content);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounting = true;
    }
  }, {
    key: 'onLoad',
    value: function onLoad() {
      if (this.unmounting) return;

      this.setState({
        isScriptLoaded: true
      });

      if (!window.CKEDITOR) {
        console.error('CKEditor not found');
        return;
      }

      this.editorInstance = window.CKEDITOR.appendTo(_reactDom2.default.findDOMNode(this), this.props.config, this.props.content);

      //Register listener for custom events if any
      for (var event in this.props.events) {
        var eventHandler = this.props.events[event];

        this.editorInstance.on(event, eventHandler);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { className: this.props.activeClass });
    }
  }]);

  return CKEditor;
}(_react2.default.Component);

CKEditor.defaultProps = {
  content: '',
  config:{
    toolbar  : [
      { name: 'document', items: [ 'Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates' ] },
      { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
      { name: 'editing', items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
      // { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
      // '/',
      { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ] },
      { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl' ] },
      { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
      { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar' ] },
      '/',
      { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
      { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
      { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
      // { name: 'about', items: [ 'About' ] }
    ],
    skin : 'moono'
    
},
  isScriptLoaded: false,
  scriptUrl: defaultScriptUrl,
  activeClass: '',
  events: {}
};

CKEditor.propTypes = {
  content: _propTypes2.default.any,
  config: _propTypes2.default.object,
  isScriptLoaded: _propTypes2.default.bool,
  scriptUrl: _propTypes2.default.string,
  activeClass: _propTypes2.default.string,
  events: _propTypes2.default.object
};

exports.default = CKEditor;